import { pathOr } from 'ramda';
import { getCookie } from '../utils/cookie';
import request, { apiURL } from '../utils/api';
export class LoggerService {
  log(
    { stack, message, userId, action }: Object,
    propertyId: string,
    orgId: string,
  ) {
    const body = {
      message: pathOr('', ['componentStack'], message),
      stack: stack.message,
      userId,
      action,
    };
    const options = {
      method: 'POST',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    };
    return request(`${apiURL}/${orgId}/${propertyId}/log`, options);
  }
}
